import EventOne from "../../../Assets/Images/BWCFront.png";
import EventTWO from "../../../Assets/Images/BWCBack.png";
import "../../../Components/SummerCamp/UpcomingEvents/upcomingevents.css";

const UpcomingEvents = () => {
  return (
    <div className="ue-container mr-b">
      <div className="ue-listing">
        <div style={{ cursor: "default" }} className="ue-card-item">
          <img src={EventOne} alt="EventsImage" />
        </div>
        <div style={{ cursor: "default" }} className="ue-card-item">
          <img src={EventTWO} alt="EventsImage" />
        </div>
      </div>
    </div>
  );
};
export default UpcomingEvents;
